import { render } from "./SEOImageOptimizer.vue?vue&type=template&id=5e6232c4"
import script from "./SEOImageOptimizer.vue?vue&type=script&lang=js"
export * from "./SEOImageOptimizer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__